import type { RibbonToggleButtonState } from "../../RibbonToggleButton/next";
import { useRibbonToggleButtonStyles } from "../../RibbonToggleButton/next";
import { useRibbonSplitButtonPrimaryButtonCustomStyles } from "./useRibbonSplitButtonPrimaryButtonStyles.styles";

export const useRibbonSplitButtonPrimaryToggleButtonStyles = (
  state: RibbonToggleButtonState
) => {
  useRibbonSplitButtonPrimaryButtonCustomStyles(state);

  useRibbonToggleButtonStyles(state as RibbonToggleButtonState);

  return state;
};
